import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {UrandaUiConfig} from "@uranda/ui";

export interface ModalPage {
  title: string;
  subtitle?: string;
  template: TemplateRef<any>;
  showActions?: boolean;
  context?: any;
}

@Component({
  selector: 'app-modal-nav',
  styleUrls: ['modal-nav.component.css'],
  templateUrl: 'modal-nav.component.html',
  standalone: false
})
export class ModalNavComponent {

  constructor(protected modal: NgbActiveModal) {
    this.iconSet = UrandaUiConfig.config?.iconSet || 'ti';
    this.customIcons = UrandaUiConfig.config?.customIcons || {};
  }
  @Input() noBodyPadding = false;
  @Input() dismissable = true;
  @Input() showActions = true;
  @Input() title?: string;
  @Input() subtitle?: string;

  @Input() iconSet: string = 'ti';
  @Input() customIcons: { [key: string]: string } = {};

  // Pagination support
  @Input() pages: ModalPage[] = [];
  @Input() currentPageIndex = 0;

  @Output() onClose = new EventEmitter<void>();
  @Output() onPageChange = new EventEmitter<number>();

  get isPaginationEnabled(): boolean {
    return this.pages && this.pages.length > 0;
  }

  get currentPage(): ModalPage | undefined {
    return this.pages[this.currentPageIndex];
  }

  get currentTitle(): string {
    return this.isPaginationEnabled && this.currentPage ? this.currentPage.title : (this.title || '');
  }

  get currentSubtitle(): string | undefined {
    return this.isPaginationEnabled && this.currentPage ? this.currentPage.subtitle : this.subtitle;
  }

  get currentShowActions(): boolean {
    return this.isPaginationEnabled && this.currentPage ? (this.currentPage.showActions ?? true) : this.showActions;
  }

  get canGoBack(): boolean {
    return this.isPaginationEnabled && this.currentPageIndex > 0;
  }

  get canGoForward(): boolean {
    return this.isPaginationEnabled && this.currentPageIndex < this.pages.length - 1;
  }

  navigateToPage(index: number) {
    if (index >= 0 && index < this.pages.length) {
      this.currentPageIndex = index;
      this.onPageChange.emit(index);
    }
  }

  goBack() {
    if (this.canGoBack) {
      this.navigateToPage(this.currentPageIndex - 1);
    }
  }

  goForward() {
    if (this.canGoForward) {
      this.navigateToPage(this.currentPageIndex + 1);
    }
  }

  close() {
    this.onClose.emit();
    this.modal.close();
  }

  protected getIcon(iconName: string): string {
    return this.customIcons[iconName] || iconName;
  }

}
